import Link from "next/link"
import React, { useEffect, useRef } from "react"
import { Col, Row } from "react-bootstrap"
import Nav from "react-bootstrap/Nav"
import { linksBuilder } from "../../../services/utils/linksBuilder"
import Container from "../../components/Layout/Container"
import { HeadingTitle } from "../../components/Layout/HeadingTitle"
import { HelmetTitle } from "../../components/Layout/HelmetTitle"
import Wrapper from "../../components/Layout/Wrapper"
import styles from "./SpaceDetailsPage.module.css"
import { imageResizer } from "../../../services/utils/imageResizer"
import classNames from "classnames"
import { SeoTags } from "../../components/Layout/SeoTags"
import { getArtworkSubtitle } from "../../../services/utils/getArtworkSubtitle"
import { getArtworkTitle } from "../../../services/utils/getArtworkTitle"

const SpaceDetailsPage = ({ spaceDetails }) => {
  const areas = {}

  const renameKeys = (keysMap, obj) =>
    Object.keys(obj).reduce(
      (acc, key) => ({
        ...acc,
        ...{ [keysMap[key] || key]: obj[key] },
      }),
      {},
    )

  const image = useRef()

  const startSpace = () => {
    console.log("startspace")
    initSpace()
    removeLoading()
  }

  spaceDetails.areas.forEach((element) => {
    const keysMap = {
      p1x: "left",
      p1y: "top",
      real_height: "realheight",
      vanishingpoint_x: "vp_x",
      vanishingpoint_y: "vp_y",
    }
    areas[element.id] = renameKeys(keysMap, element)
  })

  useEffect(() => {
    initializeArtPlacer()
    if (image.current.complete) startSpace()

    return () => {
      unbindCoreEvents()
    }
  }, [])

  const title = `${spaceDetails.gallery.name} in ${spaceDetails.space.title} | Discover ArtPlacer`

  return (
    <>
      <Wrapper>
        <SeoTags
          title={title}
          description={`Check this collection from ${spaceDetails.gallery.name} displayed in
            ${spaceDetails.space.title}. Drag and drop artworks and create a beautiful wall of art.`}
          image={imageResizer(spaceDetails.space.image, 340, `AUTO`)}
          url={`https://discover.artplacer.com/spaces/${spaceDetails.id}`}
        />
        <HelmetTitle title={title} />
        <Container>
          <Row className="mb-4">
            <Col>
              <HeadingTitle title={spaceDetails.space.title}>
                Try our partner’s collections. Drag and drop artworks and create
                a beautiful wall of art.
              </HeadingTitle>
              <Nav className="mb-3">
                <div className="nav-item">
                  <Link href="/galleries">
                    <a className="text-black text-decoration-underline px-1 font-primary fs-14px">
                      Galleries
                    </a>
                  </Link>
                </div>
                <div className="nav-item">/</div>
                <div className="nav-item">
                  <Link
                    href="/galleries/[id]"
                    as={linksBuilder.galleries(spaceDetails.gallery.domain)}
                    className="text-black text-decoration-underline px-1 font-primary fs-14px">
                    {spaceDetails.gallery.name}
                  </Link>
                </div>
              </Nav>

              <div id="space" className={styles["main-poster"]}>
                <div
                  className="container"
                  style={{ maxWidth: `${spaceDetails.space.width}px` }}>
                  <div className="workarea">
                    <div className="selections"></div>
                  </div>
                  <img
                    className="main"
                    onLoad={startSpace}
                    ref={image}
                    src={imageResizer(spaceDetails.space.image, `1290`, `AUTO`)}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <h3 className="text-black mb-3 fs-20px">Artworks</h3>
                {/*<Row className={styles["overflow-artworks"]}>*/}
                {/*  {spaceDetails.gallery.artworks.map((artwork) => (*/}
                {/*    <Col xs={6} sm={6} md={3} key={`artworks-${artwork.id}`}>*/}
                {/*      <LikeCards*/}
                {/*        title={artwork.title}*/}
                {/*        subtitle={artwork.artistname}*/}
                {/*        subSubTitle={`${artwork.height}" height`}*/}
                {/*        image={artwork.image}*/}
                {/*        href="/artworks/[id]"*/}
                {/*        to={linksBuilder.artworks(artwork.id, artwork.title)}*/}
                {/*      />*/}
                {/*    </Col>*/}
                {/*  ))}*/}
                {/*</Row>*/}
                <div
                  className={classNames(
                    `artworks`,
                    styles["overflow-artworks"],
                  )}>
                  <div className="scroll-container">
                    <div className="scrollable">
                      <div className="samples"></div>
                    </div>
                  </div>
                </div>
                <div className="all-artworks" style={{ display: "none" }}>
                  {spaceDetails.gallery.featured_artworks.map((artwork) => (
                    <div
                      className="artwork"
                      key={`artworks-${artwork.id}`}
                      id={`artworks-${artwork.id}`}
                      data-id={artwork.id}
                      data-height={artwork.height}
                      data-src={imageResizer(artwork.image, `AUTO`, `600`)}
                      data-title={artwork.title}
                      data-artistname={artwork.artistname}
                      data-width={artwork.width}>
                      <div className="img-wrapper"></div>
                      <label className="text-black fs-14px">
                        <strong>{getArtworkTitle(artwork.title)}</strong>
                      </label>
                      <label className="font-primary text-black fs-13px">
                        {getArtworkSubtitle(artwork.artistname, spaceDetails.gallery.name)}
                      </label>
                      <label className="font-primary color-gray-super-light fs-12px">{`Height: ${artwork.height}''`}</label>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Wrapper>
      <input type="hidden" id="realwidth" value={spaceDetails.space.width} />
      <input type="hidden" id="areas_props" value={JSON.stringify(areas)} />
      <style global jsx>{`
        .scroll-container .scrollable {
          white-space: nowrap;
          overflow-y: hidden;
          overflow-x: scroll;
        }
        div.samples {
          padding-bottom: 20px;
        }
        div.samples .artwork {
          display: inline-block;
          margin-right: 30px;
        }
        div.samples .artwork img {
          height: 120px;
        }
        div.samples > .artwork label {
          display: block;
          text-transform: none;
          font-weight: normal;
          letter-spacing: 0;
          margin-bottom: 0;
        }
        div.samples > .artwork label strong {
          font-family: Nunito, "sans-serif";
        }
        div.samples > .artwork .img-wrapper {
          margin-bottom: 12px;
          text-align: center;
        }
      `}</style>
    </>
  )
}
export default SpaceDetailsPage